import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

import type {
  ConsultaDaConversaoDoItem,
  ConversaoDaNotificacaoState,
} from '../../types/conversao.types';

const CONSULTA_OCIOSA: ConsultaDaConversaoDoItem = {
  situacao: 'ociosa',
  atualizando: false,
  conversao: null,
  atualizadaEm: null,
  erro: null,
};

const selectEstadoDaConversao = (state: RootState) => state.extrajudicialConversao;

function consultaDoItem(
  estado: ConversaoDaNotificacaoState,
  itemId: string | null,
): ConsultaDaConversaoDoItem {
  if (!itemId || estado.itemId !== itemId) return CONSULTA_OCIOSA;
  if (estado.erro) return { ...CONSULTA_OCIOSA, situacao: 'erro', erro: estado.erro };
  if (estado.resultado) {
    return {
      situacao: 'pronta',
      atualizando: estado.carregando,
      conversao: estado.resultado.conversao,
      atualizadaEm: estado.resultado.atualizadaEm,
      erro: null,
    };
  }
  return estado.carregando ? { ...CONSULTA_OCIOSA, situacao: 'carregando' } : CONSULTA_OCIOSA;
}

/** O estado guarda um item só: pedir por outro `itemId` devolve `ociosa`, nunca o dado alheio. */
export const selectConsultaDaConversaoDoItem = createSelector(
  [selectEstadoDaConversao, (_state: RootState, itemId: string | null) => itemId],
  consultaDoItem,
);
